import React, { useRef } from 'react';
import { iphoneAppDownload, androidAppDownload, iphoneRedeemCode } from '../link-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowCircleUp} from '@fortawesome/free-solid-svg-icons';
import LogoText from '../components/logoText';
import {Pricing} from "../components/Pricing";

import Carousel from "react-multi-carousel";

export const GolfVideo = () => {
    const introVid = useRef(null);
    const introButton = useRef(null);
    const special = useRef(null);
    let showSpecial = false;
    let sportKey = "golf";
    let promo = {
        name:'FedEx Cup Special',
        expiry: '24 Aug 2025',
        code: 'FEDEX25'
    }

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

/*
<div className="col-xl-7 col-lg-7 col-12 align-self-center" style={{marginBottom:'20px'}}>
                            <div className="atf-single-about-img text-center my-auto">
                                <h2 style={{ fontSize: '26px', lineHeight: "1.6", marginBottom: '20px' }}>Like recording your swing?</h2>
                                <h2 style={{ display:'inline-block', fontSize: '26px', marginTop: "10px", width: '50px', height: '50px', padding: '2px', borderRadius:'40px', backgroundColor: 'yellowgreen', color:"white"}}>5</h2>
                                <h2 style={{ fontSize: '26px', lineHeight: "1.6", color: "yellowgreen" }}>Reasons you'll love <LogoText light={false} /></h2>
                                <button onClick={() => { window.gtag('event', `video_play_${sportKey}_top`); introVid.current.play(); }} style={{padding: "10px 20px", fontSize: '14px', color: "white", background: "yellowgreen", border: '0px', borderRadius: '20px', marginTop:'20px'}}>Watch demo</button>


                            </div>
                        </div>

                        <div className="col-xl-5 col-lg-5 col-12 align-self-center text-center">
                            <video ref={introVid} controls width={"100%"} poster={"./watch_at_feet.png"} style={{marginTop: '20px'}}>
                                <source src="/assets/video/practiceLoopIntro.mp4" type="video/mp4" />
                            </video>

                        </div>

 */
    return (<div>
        

            <section className="atf-hero-area atf-shape" style={{padding: "50px 0px", backgroundImage: 'url(./assets/img/smokebg_dark.png)', backgroundColor: '#000000', backgroundSize: 'auto, auto'}}>
                <div className="container">
                    <div className="row justify-content-center clearfix">
                          <div className="d-none d-lg-block col-lg-7 col-0 text-center align-self-center atf-single-details pt-3">
                              <h2 style={{ marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>Real time swing analysis</h2>
                              <h4 style={{ marginTop: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>For real fast improvement</h4>

                              <div className="mt-5">
                                    <div className=" text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                                        <h4 className="heading-size"style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                                        
                                            <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                                            <a href="#" onClick={() => iphoneRedeemCode("T20WC2026M")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                                
                                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                                            <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 15 Apr 2026</div>
                                            
                                    </div>
                              </div>
                          </div>
                          <div className="col-lg-5 col-12 text-center atf-single-details">
                            <h2 className="d-block d-lg-none" style={{ marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa', paddingTop: '10px' }}>Real time swing<br />analysis</h2>
                                                                            
                            <Carousel
                                                                  swipeable={true}
                                                                  draggable={true}
                                                                  showDots={false}
                                                                  responsive={responsive}
                                                                  infinite={true}
                                                                  autoPlay={true}
                                                                  autoPlaySpeed={2500}
                                                                  keyBoardControl={true}
                                                                  customTransition="transform 300ms ease-in-out"
                                                                  transitionDuration={500}
                                                                  containerClass="carousel-container"
                                                                  dotListClass="custom-dot-list-style"
                                                                  itemClass="carousel-item-padding-40-px"
                                                                >
                                                                    <div style={{position: 'relative'}}>
                                                                        <div className="d-block d-lg-none">
                                                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>For real fast improvement</h4>
                                                                        </div>
                                                                        <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                                                    </div>

                                                                    <div style={{position: 'relative'}}>
                                                                        <div className="d-block d-lg-none">
                                                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Slow motion instant replays</h4>
                                                                        </div>
                                                                        <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                                                    </div>
                                                                    <div style={{position: 'relative'}}>
                                                                        <div className="d-block d-lg-none">
                                                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Analyze fundamentals</h4>
                                                                        </div>
                                                                        <img src="./assets/img/cricket/bowling/test1.png" alt="Elbow angle" />
                                                                    </div>
                                                                    <div style={{position: 'relative'}}>
                                                                        <div className="d-block d-lg-none">
                                                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Auto pause at key frames</h4>
                                                                        </div>
                                                                        <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                                                    </div>
                                                                    <div style={{position: 'relative'}}>
                                                                        <div className="d-block d-lg-none">
                                                                            <h4 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>Cast to tablet or laptop</h4>
                                                                        </div>
                                                                        <img src="./assets/img/cricket/bowling/test.png" alt="Elbow angle" />
                                                                    </div>
                                                                </Carousel>
                                
                          </div>
                      </div>
                      <div className="d-block d-lg-none row justify-content-center clearfix">
                            
                            <div className="text-center align-self-center p-2">
                                <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                                    <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>US Masters Special</h4>
                                    
                                    <div style={{ fontSize: '18px', lineHeight: "1.3", color: "white" }}>Try free for 30 days, then just $9.99<span style={{fontSize: '12px'}}>/year</span></div>
                                    <a href="#" onClick={() => iphoneRedeemCode("T20WC2026M")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                        
                                    <div style={{ fontSize: '14px', lineHeight: "1.3", color: "var(--thm-black)", marginBottom:'10px' }}>(Normally $29.99<span style={{fontSize: '12px'}}>/year</span>)</div>
                                    <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.<br/>Offer ends 15 Apr 2026</div>
                                </div>
                            </div>
                            </div>
                </div>
            </section>

            <section  className="atf-section-padding">
                <div className="container">
                    <div className="row justify-content-center clearfix">
                        <div className="col-lg-8 col-12 text-center align-self-center">
                            <div>
                                <h2 style={{ fontSize: '30px', marginTop: "5px", marginBottom: "10px", lineHeight: "1.5", color:"var(--thm-black)"}}>Slow motion replays, after every shot</h2>
                                <p style={{ fontSize: "18px", margin: "15px 0 20px 0" }}>Analyze your swing in real time</p>

                            </div>
                        </div>
                        <div className="col-lg-4 col-12 text-center">
                            <img src="./assets/img/golf/sequence.gif" alt="Swing detection" style={{width: "70%", marginTop: '30px'}} />
                        </div>

                    </div>
                </div>
            </section>

          <div className={"row"}>
              <div className="col-12 text-center align-self-center">
                  <div style={{marginBottom: '30px'}}>
                      <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_mid`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                      <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_mid`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                      <p>Try it yourself</p>
                  </div>
              </div>
          </div>
          <section style={{paddingTop: '40px', backgroundColor: 'yellowgreen', padding: '20px'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", marginBottom: "10px", lineHeight: "1.5", color:"white"}}>With analysis</h2>
                              <p style={{ fontSize: "18px", margin: "15px 0 20px 0", color: "white" }}>Analyze a series of swing fundamentals while the swing feeling is fresh in your mind.</p>
                          </div>
                      </div>

                  </div>
                  <div className="row clearfix align-self-center" >
                          <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}> 
                              <img src="./assets/img/cricket/bowling/elbow_angle_2.png" alt="Elbow angle" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Elbow Angle</h2>
                                </div>
                          </div>

                            <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}>
                                <img src="./assets/img/cricket/bowling/arm_angle_2.png" alt="Arm angle" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Arm Angle</h2>
                                </div>
                          </div>

                           <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}>
                                <img src="./assets/img/cricket/bowling/knee_angle.png" alt="Knee bend" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Knee Bend</h2>
                                </div>
                          </div>

                          <div className="col-lg-3 col-12 text-center" style={{padding: '2px'}}>
                                <img src="./assets/img/cricket/bowling/arm_alignment.png" alt="Arm/Leg alignment" style={{width: "80%"}} />
                                <div style={{width: "100%", marginTop:"-30px"}}>
                                    <h2 style={{ fontSize: '22px', color:"white", fontFamily: 'Comfortaa' }}>Body alignment</h2>
                                </div>
                          </div>

                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>With auto-pause</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0",  }}>Auto-pause replays at take-away, top, and impact.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings" style={{width: "85%", marginTop: '30px'}}/>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Stream replay to a tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white'  }}>Connect a tablet or laptop and see the replay on a bigger screen, at your feet.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="./assets/img/driving_range_pov.png" alt="Watch replay at your feet" style={{marginTop: '30px'}} />
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Stream replay to a tablet or laptop</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white' }}>Connect a tablet or laptop and see the replay on a bigger screen, at your feet.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Your swings are saved individually.<br/><span style={{color: 'yellowgreen'}}>For easy playback.<span style={{fontSize:'20px', verticalAlign: 'super'}}>*</span></span></h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0",  }}>All shots are automatically saved, individually, so you can re-watch them with a single tap.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="/assets/img/golf/sessionlib.png" alt="Save individual swings" style={{width: "85%", marginTop: '30px'}}/>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding" style={{background: 'var(--thm-black)'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Export your entire practice to video<span style={{fontSize:'20px', verticalAlign: 'super'}}>*</span></h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white'  }}>Create a single video with all your swings, back-to-back. Nothing in-between.</p>
                              <p style={{ fontSize: "12px", margin: "15px 0 0px 0", color:'white' }}>*IPhone only.  Coming soon to Android.</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <video controls width={"100%"}  style={{width: "90%", marginTop: '30px'}}>
                              <source src="/assets/img/golf/export_sample.mp4" type="video/mp4" />
                          </video>
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Export your entire practice to video<span style={{fontSize:'20px', verticalAlign: 'super'}}>*</span></h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:'white' }}>Create a single video with all your swings, back-to-back. Nothing in-between.</p>
                              <p style={{ fontSize: "12px", margin: "15px 0 0px 0", color:'white' }}>*IPhone only.  Coming soon to Android.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <section className="atf-section-padding" style={{background: 'yellowgreen'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"white"}}>Fast replays mean fast improvement</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0", color:"white"  }}>Watch this 60 second demo or try it yourself</p>
                              <div style={{marginTop: '30px'}}>
                                  <a href="#" onClick={() => iphoneAppDownload(`${sportKey}_video_mid`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                  <a href="#" onClick={() => androidAppDownload(`${sportKey}_video_mid`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <video ref={introVid} controls width={"100%"} poster={"./watch_at_feet.png"} style={{marginTop: '20px'}}>
                              <source src="/assets/video/website-demo-video.mp4" type="video/mp4" />
                          </video>
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Go straight to any swing. No scrolling.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0"  }}>Go to your previous or next swing with a single tap</p>
                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="/assets/img/golf/sessionnext.gif" alt="Previous Next Swings" style={{width: "76%", marginTop: '30px'}}/>
                      </div>
                      <div className="col-lg-7 col-12  d-none d-lg-block  text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Go straight to any swing. No scrolling.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0" }}>Go to your previous and next swings with scrolling through video</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
              <div className="container">
                  <div className="row justify-content-center" style={{backgroundColor: "yellowgreen"}}>
                      <div className="col-12 align-self-center text-center" style={{backgroundImage: 'url(assets/img/golf_collage.png)', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                          <div style={{ margin: '20px 10px 20px 10px', padding: '10px', background:"white"}}>
                              <h2 style={{ display: "inline-block", fontSize: '34px', lineHeight:"1.5", marginBottom: "10px", color:"var(--thm-black)",padding: "5px"}}>500+ installs</h2><br />
                              <h2 style={{ display: "inline-block", fontSize: '18px', marginBottom: "10px", lineHeight: "1.5", padding: "3px"}}>"If you like recording your swing, you'll love PracticeLoop"</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 text-center align-self-center">
                          <div>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"var(--thm-black)"}}>Don't fiddle with your phone to watch recordings.</h2>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"yellowgreen"}}>Watch every replay, after every shot.</h2>
                              <h2 style={{ fontSize: '30px', marginTop: "5px", lineHeight: "1.5", color:"#999999"}}>Hands free.</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "25px 0 0px 0"  }}>Replays after every swing, without touching your phone.</p>

                          </div>
                      </div>
                      <div className="col-lg-5 col-12 text-center">
                          <img src="./assets/img/golf/framebyframe.gif" alt="Watch frame-by-frame" style={{width: "70%", marginTop: '30px'}} />
                      </div>
                  </div>
              </div>
          </section>

        <Pricing/>
          <div className="row justify-content-center clearfix" style={{backgroundColor:'var(--thm-black)',  marginTop: '30px', padding: '25px 5px'}}>
              <div className="col-12 text-center" style={{padding:"20px"}}>
                  <h2 style={{ fontSize: "30px", margin: "0 0 10px 0", color: 'yellowgreen' }}>Swing. Replay. Improve. Repeat.</h2>
                  <div style={{color:'white', fontSize:'20px', fontWeight:"normal", lineHeight:'2rem'}}>Instant feedback after every shot</div>
                  <div style={{color:'white', fontSize:'20px', fontWeight:"normal"}}>So you can improve faster</div>
              </div>
          </div>





        <div id="get-started" className="atf-section-padding atf-footer-offset">
            <div className="atf-brand-overlay">
                <div className="container">
                    <div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                        <div className="col-lg-8 col-md-8 col-11 text-center atf-mailchamp-headding atf-mailchamp-subscribe">
                            <h2 className="mb-3 text-center">Try for free today</h2>
                            <div>
                                <a href="#none" onClick={() => iphoneAppDownload(`${sportKey}_video_bottom_cta`)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                <a href="#none" onClick={() => androidAppDownload(`${sportKey}_video_bottom_cta`)} ><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ height: '65px' }} /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}
